import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Windmill } from "@windmill/react-ui";
import "./assets/css/custom.css";
import "./assets/css/tailwind.css";
import "./assets/css/tailwind.output.css";
import "@pathofdev/react-tag-input/build/index.css";
import App from "./App";
import myTheme from "./assets/theme/myTheme";
import { AdminProvider } from "./context/AdminContext";
import { SidebarProvider } from "./context/SidebarContext";
import ThemeSuspense from "./components/theme/ThemeSuspenseEmpty";

// import * as serviceWorker from './serviceWorker';

const dotenv = require("dotenv")
dotenv.config()

ReactDOM.render(
  <AdminProvider>
    <SidebarProvider>
    <Suspense fallback={<ThemeSuspense />}>
        <Windmill usePreferences theme={myTheme}>
        
          <App />
       
        </Windmill>
      </Suspense>
    </SidebarProvider>
  </AdminProvider>,

  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();


//IMPORTANTE: EN PROD ES TRUE (QUIERO CACHEAR)
const ENABLE_SERVICE_WORKER = false;


//ESTO DESAXCTIVA EL CACHE PARA AQUELLOS QUE LO TENIAN ACTIVO Y PUEDEN ESTAR VIENDO COSAS VIEJAS
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
    });
  });

  caches.keys().then((keys) => {
    keys.forEach((key) => caches.delete(key));
  });
}

//_______________________________________

if (
  ENABLE_SERVICE_WORKER &&
  "serviceWorker" in navigator
) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/serviceworker.js")
      .then((registration) => {
        console.log(
          "Service Worker registrado:",
          registration.scope
        );
      })
      .catch((error) => {
        console.error(
          "Error registrando Service Worker:",
          error
        );
      });
  });
}